import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/providers/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
	
	constructor(private _authService: AuthService, private _router: Router) {
		
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		let currentUrl = route.routeConfig.path;
		let response:any = this._authService.isUserAuthenticated(currentUrl);
		return response;
    }
}